<template>
  <div
    id="echartsId3"
    style="width: 330px; height: 250px; margin: 0 auto"
  ></div>
</template>

<script>
export default {
  methods: {
    chartint() {
      let myChart = this.$echarts.init(document.getElementById("echartsId3"));
      var option;

      option = {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            color: ["#054476"],
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            barWidth: 26, // 柱形宽度（折线图无）
          },
        ],
        grid: {
          bottom: "10%",
          top: "3%",
        },
      };

      option && myChart.setOption(option);
    },
  },
  mounted() {
    this.chartint();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/echarts/StackChart.vue